import { useState, useEffect } from 'react'
import { ChevronDown } from 'lucide-react'

interface ScrollIndicatorProps {
  targetId: string
  text?: string
  className?: string
}

export default function ScrollIndicator({ 
  targetId, 
  text = "Scroll to explore", 
  className = "" 
}: ScrollIndicatorProps) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      
      // Calculate how close we are to the bottom
      const distanceFromBottom = documentHeight - (scrollY + windowHeight)
      
      // Hide indicator when scrolled past 60% of viewport height OR when close to bottom
      const isNearTop = scrollY < windowHeight * 0.6
      const isNearBottom = distanceFromBottom < 200 // 200px from bottom
      
      setIsVisible(isNearTop && !isNearBottom)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToTarget = () => {
    const target = document.getElementById(targetId)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className={`fixed bottom-8 left-1/2 transform -translate-x-1/2 transition-opacity duration-500 z-50 ${
      isVisible ? 'opacity-100' : 'opacity-0'
    } ${className}`}>
      <button
        onClick={scrollToTarget}
        className="flex flex-col items-center space-y-2 text-white hover:text-blue-300 transition-colors group"
      >
        <span className="text-sm font-medium">{text}</span>
        <ChevronDown className="h-6 w-6 group-hover:scale-110 transition-transform animate-bounce" />
      </button>
    </div>
  )
} 